import axios from '@/store/config';
import { NOT_A_VACANT_RENTALOBJECT } from '@/config/constants';

export default {
  state: {
    rentalObjects: []
  },
  getters: {

    /**
     * Leta igenom samlingen rentalobjekt på rentalObjectCode
     */
    getObjectByObjectCode: (state) => (objectCode) => {
      return state.rentalObjects.find((singelObject) => singelObject.rentalObjectCode == objectCode);
    }
  },
  actions: {

    /**
     * Hämta enkilt rentalobjekt på rentalObjectCode
     */
    fetchSingleRentalObject({ commit }, objectCode) {
      return new Promise((resolve, reject) => {
        if(!objectCode || objectCode=='' || objectCode == undefined){
          return reject(NOT_A_VACANT_RENTALOBJECT)
        }

        axios.get('/rentalobjects/' + objectCode).then((response) => {
          commit('pushRentalObjects', response.data);

          return resolve(response.data);
        }).catch((err) => {
          return reject(err);
        })
      })
    }
  },
  mutations: {

    /**
     * Lägg till rentalobjekt i samlingen.
     * Ersätter eventuell tidigare version
     */
    pushRentalObjects(state, data){
      state.rentalObjects = [
        ...state.rentalObjects.filter(n => n.rentalObjectCode != data.rentalObjectCode),
        data
      ]
    }
  }
}
